/**
 * Weekly snapshot shape (mirrors the documented `WeeklySnapshot` API
 * contract — see docs/home-redesign/DESIGN.md §9):
 *
 *   {
 *     totalWorkouts, totalDurationMin, totalVolumeKg, totalCalories,
 *     activeDays, streak,
 *     weeklyGoal: { current, target },
 *     dailyActivity: [{ day, label, volumeKg }],  // Mon -> Sun
 *   }
 */

export const WEEKLY_SNAPSHOT = {
  totalWorkouts: 5,
  totalDurationMin: 402, // 6h 42m
  totalVolumeKg: 38450,
  totalCalories: 2940,
  activeDays: 5,
  streak: 9,
  weeklyGoal: { current: 5, target: 6 },
  dailyActivity: [
    { day: "Mon", label: "Mon", volumeKg: 8200 },
    { day: "Tue", label: "Tue", volumeKg: 3100 },
    { day: "Wed", label: "Wed", volumeKg: 9700 },
    { day: "Thu", label: "Thu", volumeKg: 4200 },
    { day: "Fri", label: "Fri", volumeKg: 8000 },
    { day: "Sat", label: "Sat", volumeKg: 1200 },
    { day: "Sun", label: "Sun", volumeKg: 0 },
  ],
};
